import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import MuiAutocomplete from '@material-ui/lab/Autocomplete';
import { FieldValidation } from '@rjsf/utils';
import {
  CustomFieldExtensionSchema,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import {
  ALLOWED_COMPANIES,
  ALLOWED_INITIATIVES,
} from '@eng-portal/czi-extensions-common';

const LISTS: Record<string, readonly string[]> = {
  companies: ALLOWED_COMPANIES,
  initiatives: ALLOWED_INITIATIVES,
};

export function StrictEnumPicker({
  onChange,
  rawErrors,
  required,
  formData,
  schema: { title, description },
  uiSchema,
}: FieldExtensionComponentProps<string>): JSX.Element {
  const listName = (uiSchema?.['ui:options']?.listName as string) ?? '';
  const options = [...(LISTS[listName] ?? [])];

  return (
    <MuiAutocomplete
      value={formData ?? ''}
      options={options}
      getOptionLabel={option => option}
      onChange={(_event, value) => onChange((value as string) ?? '')}
      renderInput={params => (
        <MuiTextField
          {...params}
          label={title}
          helperText={description}
          margin="dense"
          variant="outlined"
          required={required}
          error={!!rawErrors?.length}
        />
      )}
    />
  );
}

export const StrictEnumPickerSchema: CustomFieldExtensionSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      listName: {
        type: 'string',
        title: 'Name of the allowed-values list (e.g. "companies", "initiatives")',
      },
    },
  },
  returnValue: {
    type: 'string',
  },
};

export const StrictEnumPickerValidation = (
  formData: string,
  validation: FieldValidation,
): void => {
  if (!formData || formData.trim() === '') {
    validation.addError('This field is required.');
    return;
  }
  // The zod schema enforces the allowed values at submission time,
  // so no need to duplicate the check here.
};
